// icon:shopping-cart-fill | Remix Icon https://remixicon.com/ | Remix Design
import * as React from "react";

function IconShoppingCartFill(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M6 9h13.938l.5-2H8V5h13.72a1 1 0 01.97 1.243l-2.5 10a1 1 0 01-.97.757H5a1 1 0 01-1-1V4H2V2h3a1 1 0 011 1v6zm0 14a2 2 0 110-4 2 2 0 010 4zm12 0a2 2 0 110-4 2 2 0 010 4z" />
    </svg>
  );
}

export default IconShoppingCartFill;
